module.exports = __webpack_public_path__ + "img/logo1.e381f0b8.png";